import { featuredReads } from "../data";

const images = [
  "https://readdy.ai/api/search-image?query=Editorial%20magazine%20layout%20photograph%20of%20a%20smartphone%20tripod%20on%20a%20busy%20sunlit%20sidewalk%20held%20by%20an%20out%20of%20focus%20figure%20from%20behind%2C%20warm%20documentary%20tones%2C%20cinematic%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20thoughtful%20media%20analysis%20mood&width=900&height=700&seq=dashan-read-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Editorial%20documentary%20style%20image%20of%20a%20city%20street%20crowd%20seen%20from%20above%20in%20blurred%20warm%20motion%2C%20people%20faces%20abstracted%20and%20soft%2C%20cream%20and%20terracotta%20tones%2C%20cinematic%20film%20grain%2C%20commentary%20on%20privacy%20in%20public%20spaces&width=900&height=700&seq=dashan-read-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photography%20of%20a%20journalist%20notebook%20and%20voice%20recorder%20on%20a%20wooden%20cafe%20table%20by%20a%20window%2C%20warm%20natural%20light%2C%20cream%20and%20amber%20tones%2C%20calm%20documentary%20mood%2C%20no%20people%20visible&width=900&height=700&seq=dashan-read-03&orientation=landscape",
];

export default function FeatureReads() {
  return (
    <section id="reading" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-primary-600 font-semibold tracking-wide text-sm">FEATURE · 深度阅读</p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
              不止吃瓜，更要看懂背后
            </h2>
          </div>
          <a href="#timeline" className="inline-flex items-center gap-1 text-primary-600 text-sm font-medium whitespace-nowrap">
            事件脉络梳理 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-5">
          {featuredReads.map((f, i) => (
            <article
              key={f.title}
              className="group flex flex-col rounded-2xl overflow-hidden border border-background-200 bg-background-100 hover:shadow-md transition"
            >
              <div className="relative overflow-hidden">
                <img
                  src={images[i]}
                  alt={`深度阅读专题配图：${f.title}`}
                  className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-primary-700 text-xs font-semibold">
                  深度
                </span>
              </div>

              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition">
                  {f.title}
                </h3>
                <p className="mt-2.5 text-sm leading-6 text-foreground-600">{f.lead}</p>
                <ul className="mt-4 space-y-2">
                  {f.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 shrink-0"></i>
                      {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto pt-5 flex items-center justify-between border-t border-background-200">
                  <span className="text-xs text-foreground-400">{f.readTime}</span>
                  <a
                    href="#about"
                    className="inline-flex items-center gap-1 text-primary-600 text-sm font-medium"
                    aria-label={`展开阅读：${f.title}`}
                  >
                    展开全文 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}